import { TokenRequest } from "./authContext";

export const isEmpty = (obj: any) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};

export const delay = (ms: number) => {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
};

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const hasAdminRole = (roles?: string): boolean =>
  !!(roles && roles.includes("volunteer_portal:admin"));
export const hasVolunteerRole = (roles?: string): boolean =>
    !!(roles && roles.includes("DU Volunteer"));
export const hasStaffRole = (roles?: string): boolean =>
  !!(roles && roles.includes("Staff"));
export const hasPrintRole = (roles?: string): boolean =>
  !!(roles && roles.includes("volunteer_portal:print"));
export const hasFormsRole = (roles?: string): boolean =>
  !!(roles && roles.includes("volunteer_portal:forms"));
export const hasECAdminRole = (roles?: string): boolean =>
  !!(roles && roles.includes("volunteer_portal:ecadmin"));

export const getFileIcon = (url: string) => {
  const fileName = getBlobName(url);
  const parts = fileName.split(".");
  const ext = parts[parts.length - 1]?.toLowerCase();
  switch (ext) {
    case "pdf":
      return "file-pdf";
    case "doc":
      return "file-word";
    case "docx":
      return "file-word";
    case "docm":
      return "file-word";
    case "ppt":
      return "file-powerpoint";
    case "pptx":
      return "file-powerpoint";
    case "pptm":
      return "file-powerpoint";
    case "csv":
      return "file-csv";
    case "xls":
      return "file-excel";
    case "xlsx":
      return "file-excel";
    case "xlsb":
      return "file-excel";
    case "xlsm":
      return "file-excel";
    default:
      return "file-alt";
  }
};
export const getBlobName = (url: string): string => {
  const regEx = new RegExp(/^files%2F/, 'g');
  const parts = url.split("/");
  const result = parts[parts.length - 1];
  const sanitized = result.replace(regEx, '');
  console.log('getBlobName', result, sanitized);
  return sanitized;
};
export const getFileName = (url: string): string => {
  const fileName = getBlobName(url);
  const decodedParts = decodeURIComponent(fileName).split("/");
  console.log('fileName', fileName, decodedParts[decodedParts.length - 1]);
  // Files are stored in a single directory. Not nested.
  return decodedParts ? decodedParts[decodedParts.length - 1] : "";
};
export const getFileExtension = (path: string) => {
  const parts = path.split(".");
  return parts[parts.length - 1];
};
export const getHeaders = (
  apiKey?: string,
  token?: any,
  contentType: string | null = "application/json"
) => {
  const headers = new Headers();
  if (contentType) {
    headers.set("Content-Type", contentType);
  }
  if (token) {
    headers.set(
      "authorization",
      token.idToken ? `Bearer ${token.idToken}` : ""
    );
    if (token.accessToken) {
      headers.set("accesstoken", token.accessToken);
    }
  }
  if (apiKey) {
    headers.set("X-Ducks-Volunteer-Subscription-Key", apiKey);
  }
  return headers;
};
export const getTokenAndFetchHeaders = async (
  getToken: TokenRequest | any,
  args: any,
  apiKey: string,
  contentType: string | null = "application/json"
) => {
  const token = await getToken(args);
  return getHeaders(apiKey, token, contentType);
};

export const capitalize = (str: string): string =>
  str && str.charAt(0).toUpperCase() + str.slice(1);

// https://dmitripavlutin.com/how-to-compare-objects-in-javascript/
export const areEqual = (object1: any, object2: any) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !areEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object: any) => {
  return object != null && typeof object === "object";
};

export const numberToCurrency = (num: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(num);

export const formatDate = (d: string) => {
  const cDate = new Date(d);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  }).format(cDate);
};

export const isFutureDate = (value: string) => {
  const d_now = new Date();
  const d_inp = new Date(value);
  return d_now.getTime() <= d_inp.getTime();
}

const omitTypename = (key: string, value: any) => {
  return key === "__typename" ? undefined : value;
};
export const removeTypename = (variables: any) => {
  if (variables) {
    variables = JSON.parse(JSON.stringify(variables), omitTypename);
  }
  return variables;
};
